import React from 'react'
import { Columns, Column } from 'react-flex-columns'
import Centered from 'shared/ui/Centered'
import Logo from 'shared/ui/Logo'
import { Link } from '../ui/Link'
import './LandingLayout.scss'

function WebsiteLayout({ children }) {
  return (
    <>
      <div className="landing-layout">
        <Header />
        <main>{children}</main>
        <Footer />
      </div>
      {process.env.GATSBY_ACTIVE_ENV !== 'production' && (
        <div className="display-active-environment">{process.env.GATSBY_ACTIVE_ENV}</div>
      )}
    </>
  )
}

function Header() {
  return (
    <header className="landing-header">
      <Centered>
        <Columns split middle>
          <Column>
            <Logo size={6} withIcon />
          </Column>
          <Column>
            <nav className="landing-nav">
              <Link
                activeClassName="active"
                href="/contact"
                className="button button-small button-light"
              >
                Get In Touch
              </Link>
            </nav>
          </Column>
        </Columns>
      </Centered>
    </header>
  )
}

function Footer() {
  return (
    <footer className="landing-footer">
      <Centered>
        <div className="landing-footer-inner">
          <img src="/images/eye-heart-react.svg" alt="I Heart React" className="i♥react" />
          <div className="landing-footer-content">
            <a href="mailto:hello@reacttraining.com" aria-label="Email hello@reacttraining.com">
              hello@reacttraining.com
            </a>
            <span>&copy; {new Date().getFullYear()} ReactTraining.com</span>
          </div>
        </div>
      </Centered>
    </footer>
  )
}

export default WebsiteLayout
